import { IconSettings } from '@tabler/icons-react';
import { useFela } from 'react-fela';
import { FormattedMessage } from 'react-intl';

import { config } from '@/config/config';
import { Link } from '@/modules/ui';

import * as felaRules from '../VaultLink/VaultLink.rules';

// Drawn as one more row of the sidebar's vault list, hence the shared rules.
export const ManageVaultsLink = () => {
    const { css } = useFela();

    return (
        <Link type='router' to={config.routes.vaultsSettings} customStyle={felaRules.item}>
            <span className={css(felaRules.label)}>
                <IconSettings size={16} className={css(felaRules.icon)} />
                <span className={css(felaRules.name)}>
                    <FormattedMessage id='vaults.actions.manage' />
                </span>
            </span>
        </Link>
    );
};
